import { render, staticRenderFns } from "./BusPackages.vue?vue&type=template&id=0110aee3&scoped=true&"
import script from "./BusPackages.vue?vue&type=script&lang=js&"
export * from "./BusPackages.vue?vue&type=script&lang=js&"
import style0 from "./BusPackages.vue?vue&type=style&index=0&id=0110aee3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110aee3",
  null
  
)

export default component.exports